import { CommonConfirmDialog } from '@/components/Common/CommonConfirmDialog';

type RemoveUserModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const RemoveUserModal = ({
  isOpen,
  onClose,
  onConfirm,
}: RemoveUserModalProps) => {
  return (
    <CommonConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      icon="fa-light fa-trash-can"
      title="Remove account?"
      content="Are you sure you want to remove this account?"
      confirmButtonText="Remove"
      onConfirm={onConfirm}
    />
  );
};
